export type SocialLinkId = "instagram" | "telegram" | "linkedin" | "facebook" | "website";

export interface SocialLink {
  id: SocialLinkId;
  label: string;
  handle: string;
  href: string;
}

export const socialLinks: SocialLink[] = [
  {
    id: "instagram",
    label: "Instagram",
    handle: "@social.akfa",
    href: "https://www.instagram.com/social.akfa/",
  },
  {
    id: "telegram",
    label: "Telegram",
    handle: "@akfamedlinesocialuz",
    href: "https://t.me/akfamedlinesocialuz",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    handle: "Social by AKFA",
    href: "https://www.linkedin.com/company/akfa-social",
  },
  {
    id: "facebook",
    label: "Facebook",
    handle: "Social by AKFA",
    href: "https://www.facebook.com/profile.php?id=61582319195195",
  },
  {
    id: "website",
    label: "Официальный сайт",
    handle: "social.uz",
    href: "https://social.uz",
  },
];
